import React from 'react'
import { Link, } from "react-router-dom";
import { Button } from 'antd';
import { HomeOutlined } from "@ant-design/icons"
import "./unauthorized.css"
export default function Unauthorized() {
    return (
        <div className='notfoundContainer'>
            <h1>401</h1>
            <h3>Authorization Required.</h3>
            <p>You do not have the permission to access this page.</p>
            <Button type='primary' ><Link to="/" className='d-flex align-items-center' ><HomeOutlined className='not-found-icon' /> Dashboard</Link></Button>
        </div>
    )
}
